export function refinementsToQuery(refinements) {
    if (!refinements) {
        return {};
    }

    return Object.keys(refinements).reduce((query, refinementKey) => {
        const refinement = refinements[refinementKey];
        const property = refinement.split(':')[0];
        const value = encodeURIComponent(refinement.split(':')[1]);

        query[property] = value;

        return query;
    }, {});
}
